import { VStack } from '@chakra-ui/react';

import PartnerGeneralPartner from './accordionSections/PartnerGeneralPartner';
import PartnerGeneralContact from './accordionSections/PartnerGeneralContact';

// Add Mode fields
import PartnerName from './formFields/PartnerName';
import HostHeader from './formFields/HostHeader';
import DefaultPartnerPlan from './formFields/DefaultPartnerPlan';

// eslint-disable-next-line no-unused-vars
const PartnerGeneral = ({
    darkMode,
    errors,
    touched,
    isAddMode,
    defaultPlansData,
}) => {
    return (
        <VStack spacing={1} align="stretch">
            {isAddMode && (
                <>
                    <PartnerName
                        key="partnerName"
                        errors={errors}
                        darkMode={darkMode}
                        isAddMode={isAddMode}
                    />
                    <HostHeader
                        key="hostHeader"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                    <DefaultPartnerPlan
                        key="defaultPartnerPlan"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                        isAddMode={isAddMode}
                        defaultPlansData={defaultPlansData}
                    />
                </>
            )}
            {!isAddMode && (
                <>
                    <PartnerGeneralPartner
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                        isAddMode={isAddMode}
                    />
                    <PartnerGeneralContact
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                </>
            )}
        </VStack>
    );
};

export default PartnerGeneral;
